// Third party library
import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Moment from 'moment';

// Models
import PaymentModel from "../../../../data/models/payment/payment";

// History
import History from '../../../../history';

// Redux Store
import { closeLoader, openLoader } from "../../../../redux-store/loader";
import { openModal , closeModal } from '../../../../redux-store/modal';

// Components
import { Button, Header, Icon, Segment, Table } from "semantic-ui-react";

// Locales
import I18n from "../../../../i18n";

// Styles
import './plans.scss'

class ProPlans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      plans: [],
      column: 'createdAt',
      direction: null,
    };
  }

  componentDidMount() {
    this.getPlans();
  }

  getPlans = async () => {

    try {

      this.props.openLoader();
      const plans = await PaymentModel.getProPlans();

      this.setState({
        loaded: true,
        plans: plans.data,
      });

    } catch (error) {

      console.error("error", error);

    } finally {

      this.props.closeLoader();
      this.setState({ loaded: true });

    }

  };

  handleSort = clickedColumn => () => {
  
    const { column, plans, direction } = this.state;

    if (column !== clickedColumn) {

        this.setState({
            column: clickedColumn,
            plans: clickedColumn === 'createdAt' ? plans.sort((a, b) => Moment(a[clickedColumn]).diff(b[clickedColumn])) : _.sortBy(plans, [clickedColumn]),
            direction: 'ascending',
        })

        return;

    }

    this.setState({
        plans: plans.reverse(),
        direction: direction === 'ascending' ? 'descending' : 'ascending'
    });
  
  }

  onAddPlan = () => History.push('/home/pro/plans/new');

  onEditPlan = (planId) => History.push(`/home/pro/plans/${planId}`);


  removePlan = async planId => {
  
          try {
  
              this.props.openLoader();
              await PaymentModel.deleteProPlan(planId);
  
          } catch (error) {
  
              console.error('Error: ', error);
  
          } finally {
  
              this.props.closeLoader();
              this.getPlans();
  
          }
  
  }

  onRemovePlan = (planId) => {

    const message = {
      title: I18n.t('plans.removePlan'),
      buttons: [{
          text: I18n.t('actions.accept'),
          callback: async () => {

              this.removePlan(planId);
              this.props.closeModal();

          }
      }, {
          text: I18n.t('actions.cancel'),
          callback: this.props.closeModal
      }]
    };

    this.props.openModal(message);

  }

  onRenderTable = () => {

    const { column, direction } = this.state;

    return (
      <Table celled selectable sortable>
          <Table.Header>
              <Table.Row>
                  <Table.HeaderCell onClick={ this.handleSort('logo') } sorted={ column === 'email' ? direction : null }>{ I18n.t('plans.logo') }</Table.HeaderCell>
                  <Table.HeaderCell onClick={ this.handleSort('name') } sorted={ column === 'countryName' ? direction : null }>{ I18n.t('plans.name') }</Table.HeaderCell>
                  <Table.HeaderCell onClick={ this.handleSort('maxStudents') } sorted={ column === 'genderName' ? direction : null }>{ I18n.t('plans.maxStudents') }</Table.HeaderCell>
                  <Table.HeaderCell onClick={ this.handleSort('monthlyPrice') } sorted={ column === 'name' ? direction : null }>{ I18n.t('plans.monthlyPrice') }</Table.HeaderCell>
                  <Table.HeaderCell onClick={ this.handleSort('annualPrice') } sorted={ column === 'name' ? direction : null }>{ I18n.t('plans.annualPrice') }</Table.HeaderCell>
                  <Table.HeaderCell onClick={ this.handleSort('createdAt') } sorted={ column === 'createdAt' ? direction : null }>{ I18n.t('plans.registerDate') }</Table.HeaderCell>                           
                  <Table.HeaderCell>{ I18n.t('actions.edit') }</Table.HeaderCell>
                  <Table.HeaderCell>{ I18n.t('actions.remove') }</Table.HeaderCell>
              </Table.Row>
          </Table.Header>
          <Table.Body>
            { this.state.plans.map(plan => (
                <Table.Row key={ plan._id } >
                    <Table.Cell>{ plan.logo ? <img src={plan.logo} alt="Plan logo" width={60} height={60}/> : I18n.t('plans.noDefined') }</Table.Cell>
                    <Table.Cell>{ plan.name || I18n.t('plans.noDefined') }</Table.Cell>
                    <Table.Cell>{ plan.maxStudents || I18n.t('plans.noDefined') }</Table.Cell>
                    <Table.Cell>{ plan.monthlyPrice || I18n.t('plans.noDefined') }</Table.Cell>
                    <Table.Cell>{ plan.annualPrice || I18n.t('plans.noDefined') }</Table.Cell>
                    <Table.Cell>{ plan.createdAt ? Moment(plan.createdAt).format('DD/MM/YYYY HH:mm:ss') : I18n.t('plans.noCreatedAt') }</Table.Cell>
                    <Table.Cell textAlign='center'><Icon className="pointer" name="edit" size="large" onClick={ () => this.onEditPlan(plan._id) }></Icon></Table.Cell>
                    <Table.Cell textAlign='center'><Icon className="pointer" name="eraser" size="large" onClick={ () => this.onRemovePlan(plan._id) }></Icon></Table.Cell>
                </Table.Row>
            )) }
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
                <Table.HeaderCell colSpan='9'>
                    <Button type='button' floated='right' primary onClick={this.onAddPlan}>{I18n.t('plans.add')}</Button>
                    <div style={{ clear: "both" }}></div>
                </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
      </Table>
    );
        
  }

  render() {
    return (
      <Segment>
        <Header as='h3'>{ I18n.t('plans.planList') }</Header>
        { this.state.loaded && this.onRenderTable() }
      </Segment>
    )
  }
}

export default connect(null, { openLoader, closeLoader, openModal, closeModal })(ProPlans);
